import { render, staticRenderFns } from "./UpdateProfileRequestEdit.vue?vue&type=template&id=a01d6976&"
import script from "./UpdateProfileRequestEdit.vue?vue&type=script&lang=js&"
export * from "./UpdateProfileRequestEdit.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProfileRequestEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports